export default __webpack_public_path__ + "static/media/1085.fa00d4a8.png";